/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/job.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiPeriodicSchedule } from './ApiPeriodicSchedule';
import {
  ApiPeriodicScheduleFromJSON,
  ApiPeriodicScheduleFromJSONTyped,
  ApiPeriodicScheduleToJSON,
  ApiPeriodicScheduleToJSONTyped,
} from './ApiPeriodicSchedule';
import type { ApiCronSchedule } from './ApiCronSchedule';
import {
  ApiCronScheduleFromJSON,
  ApiCronScheduleFromJSONTyped,
  ApiCronScheduleToJSON,
  ApiCronScheduleToJSONTyped,
} from './ApiCronSchedule';

/**
 * Trigger defines what starts a pipeline run.
 * @export
 * @interface ApiTrigger
 */
export interface ApiTrigger {
  /**
   *
   * @type {ApiCronSchedule}
   * @memberof ApiTrigger
   */
  cron_schedule?: ApiCronSchedule;
  /**
   *
   * @type {ApiPeriodicSchedule}
   * @memberof ApiTrigger
   */
  periodic_schedule?: ApiPeriodicSchedule;
}

/**
 * Check if a given object implements the ApiTrigger interface.
 */
export function instanceOfApiTrigger(value: object): value is ApiTrigger {
  return true;
}

export function ApiTriggerFromJSON(json: any): ApiTrigger {
  return ApiTriggerFromJSONTyped(json, false);
}

export function ApiTriggerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiTrigger {
  if (json == null) {
    return json;
  }
  return {
    cron_schedule:
      json['cron_schedule'] == null ? undefined : ApiCronScheduleFromJSON(json['cron_schedule']),
    periodic_schedule:
      json['periodic_schedule'] == null
        ? undefined
        : ApiPeriodicScheduleFromJSON(json['periodic_schedule']),
  };
}

export function ApiTriggerToJSON(json: any): ApiTrigger {
  return ApiTriggerToJSONTyped(json, false);
}

export function ApiTriggerToJSONTyped(
  value?: ApiTrigger | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cron_schedule: ApiCronScheduleToJSON(value['cron_schedule']),
    periodic_schedule: ApiPeriodicScheduleToJSON(value['periodic_schedule']),
  };
}
